import { render, staticRenderFns } from "./ImagesOrtext.vue?vue&type=template&id=09fcf06c&scoped=true"
import script from "./ImagesOrtext.vue?vue&type=script&lang=js"
export * from "./ImagesOrtext.vue?vue&type=script&lang=js"
import style0 from "./ImagesOrtext.vue?vue&type=style&index=0&id=09fcf06c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fcf06c",
  null
  
)

export default component.exports